import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {NgxPermissionsModule} from "ngx-permissions";
import {TaskItemComponent} from "./components/task-item/task-item.component";
import {TaskRelationCardComponent} from "./components/task-relation-card/task-relation-card.component";
import {TaskCapacityBarsComponent} from "./components/task-capacity-bars/task-capacity-bars.component";
import {TaskStatusButtonComponent} from "./components/task-status-button/task-status-button.component";
import {TaskPlannedEtaComponent} from "./components/task-planned-eta/task-planned-eta.component";
import {
  TaskDetailedServiceTimeComponent
} from "./components/task-detailed-service-time/task-detailed-service-time.component";
import {
  TaskDetailedServiceTimeEditComponent
} from "./components/task-detailed-service-time-edit/task-detailed-service-time-edit.component";

@NgModule({
  declarations: [
    TaskItemComponent,
    TaskRelationCardComponent,
    TaskCapacityBarsComponent,
    TaskStatusButtonComponent,
    TaskPlannedEtaComponent,
    TaskDetailedServiceTimeComponent,
    TaskDetailedServiceTimeEditComponent
  ],
  imports: [
    BrowserModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild()
  ],
  exports: [
    TaskItemComponent,
    TaskStatusButtonComponent,
    TaskPlannedEtaComponent,
    TaskDetailedServiceTimeComponent
  ],
  providers: []
})

export class TasksModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapTasksModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(TasksModule);
};

export const downgradedTasksModule = downgradeModule(bootstrapTasksModule);
